import { render, staticRenderFns } from "./ModifierPriority.vue?vue&type=template&id=a99c7ebc&scoped=true"
import script from "./ModifierPriority.vue?vue&type=script&lang=js"
export * from "./ModifierPriority.vue?vue&type=script&lang=js"
import style0 from "./ModifierPriority.vue?vue&type=style&index=0&id=a99c7ebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99c7ebc",
  null
  
)

export default component.exports